module.exports = __webpack_public_path__ + "193d2e06baf8941c7483b4494f0456e6.png";